<template>
  <div>
    <v-snackbar
      v-model="internalSnackbar"
      :color="snackbarColor"
      tile
      top
      right
      class="white--text"
      :timeout="timeout"
    >
      {{ text }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Snackbar",
  props: {
    snackbar: Boolean,
    text: String,
    timeout: {
      type: Number,
      default: 3000
    },
    type: {
      type: String,
      default: "success",
      validator(value) {
        return (
          value === undefined ||
          value === null ||
          value === "" ||
          ["success", "warning", "danger"].includes(value)
        );
      }
    }
  },
  data() {
    return {
      internalSnackbar: false
    };
  },
  computed: {
    snackbarColor() {
      const normalizedType = this.type || "success";
      switch (normalizedType) {
        case "warning":
          return "yellow darken-2";
        case "danger":
          return "red darken-2";
        case "success":
        default:
          return "green lighten-2";
      }
    }
  },
  watch: {
    snackbar(newSnackbarValue) {
      this.internalSnackbar = newSnackbarValue;
    }
  }
};
</script>
